import { isWeb } from "../../bridges/BridgeServices";
import { isTokenPresent } from "../../utils/cookieHelper";
import "./Chatbot.scss";
import PropTypes from "prop-types";

const Chatbot = () => {
  // load chatbot sdk when there's a token in the cookie
  if (!isWeb()) {
    return null;
  }

  if (
    isTokenPresent() &&
    !document?.getElementById("mobile-chat-container")
  ) {
    require("./ChatbotSdk");
  }
  return null;
};

export default Chatbot;

Chatbot.propTypes = {
  faqTitle: PropTypes.string,
};
